import { useState, useEffect } from "react";
import { 
    Route, 
    Routes, 
    Link, 
    useNavigate, 
    useLocation,
    Navigate, 
    useParams 
} from 'react-router-dom';

import config from '../config';

import Helmet from "./Helmet";
import Breadcrumbs from "./Breadcrumbs";
import Sidebar from "./Sidebar";
import { statusTranslations } from "../helpers/translations";
import MatchInfo from "./MatchInfo";
import MatchProgress from "./MatchProgress";
import MatchStatistic from "./MatchStatistic";
import MatchCoefficients from "./MatchCoefficients";
import MatchTable from "./MatchTable";
import H2H from "./H2H";
import Banner from "./Banner";
import { joinUrl } from '../helpers/joinUrl';
import TeamArrangement from "./TeamArrangement";

function Match(){

    const {matchid} = useParams();
    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [tab, setTab] = useState('match');

    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname.split('/');
    const tabPathIndex = path.indexOf('match') + 2;
    const currentTab = tabPathIndex != -1 ? path[tabPathIndex] : "";

    useEffect(() => {
        const time = 60000;
        const urlData = {
            id: matchid,
        };
        const urlParams = new URLSearchParams(urlData).toString();
        const url = joinUrl(config.API_URL, 'match.php?' + urlParams);

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await fetch(url, {
                    method: 'GET',
                });
                const textData = await response.text();
                console.log(`textData: ${textData}`);
                const jsonData = JSON.parse(textData);
                console.log(`jsonData: ${jsonData}`);
                setData(jsonData);
            } catch (error) {
                console.error('Ошибка загрузки данных:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        const intervalId = setInterval(fetchData, time);

        return () => clearInterval(intervalId);

    }, []);

    const status = () => {
        if (!data) return;
        switch (data.maindata[0].status) {
            case "1": return null; 
        }
        return statusTranslations[data.maindata[0].status];
    }

    const time = () => {
        if (!data) return;
        switch (data.maindata[0].status){
            case "1": {
                const timestamp = data.maindata[0].start_time;
                const date = new Date(timestamp * 1000);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                const hours = date.getHours();
                const minutes = "0" + date.getMinutes();
                const formattedTime = `${day}.${month}.${year} ${hours}:${minutes.substr(-2)}`;
                return formattedTime;
            }
            case "3": {
                const timestamp = data.maindata[0].end_time;
                const date = new Date(timestamp * 1000);
                const day = date.getDate();
                const month = date.getMonth()+1;
                const year = date.getFullYear();
                const hours = date.getHours();
                const minutes = "0" + date.getMinutes();
                const formattedTime = `${day}.${month}.${year} ${hours}:${minutes.substr(-2)}`;
                return formattedTime;
            }
        }
    }

    const score = () => {
        if (!data) return;
        switch (data.maindata[0].status) {
            case "1":
                return (<div className="game__score">vs</div>); 
            case "2":
            case "3":
                return (
                <div className="game__score">
                    <span>{data.maindata[0].commandA_score}</span>
                    <span> - </span>
                    <span>{data.maindata[0].commandB_score}</span>
                </div>);
        }
    }

    const breadcrumbsData = () => {
        if (!data) return;
        const category = data?.htmldata?.header?.tournament?.category;
        const tournament = data?.htmldata?.header?.tournament?.tournament;
        if (!category || !tournament) return;
        return [category, tournament];
    }

    function getHelmet () {

        if (!data) return;

        const tabnameTranslations = {
            "coeff": "Коэффициенты",
            "h2h": "H2H",
            "table": "Таблица",
            "team": "Составы",
        };

        const tabname = tabnameTranslations[tab];
        const playerAName = data?.htmldata?.participantsData?.home[0].name;
        const playerBName = data?.htmldata?.participantsData?.away[0].name;
        if (!tabname || !playerAName || !playerBName) return;
        const title = `${playerAName} - ${playerBName}  | ${tabname}`;

        const tournamentCategory = data?.htmldata?.header?.tournament?.category;
        const tournamentText = data?.htmldata?.header?.tournament?.tournament;
        if (!tournamentCategory || !tournamentText) return;
        const description = `${tournamentCategory}: ${tournamentText}`;

        return (<Helmet
            title={title}
            description={description}
        />);
    }

    if (!data) return;

    const helmet = getHelmet() || null;

    const participantA = {
        imagePath: data?.htmldata?.participantsData?.home[0].image_path || "",
        name: data?.htmldata?.participantsData?.home[0].name || "",
    };

    const participantB = {
        imagePath: data?.htmldata?.participantsData?.away[0].image_path || "",
        name: data?.htmldata?.participantsData?.away[0].name || "",
    };

    return (<section class="main-section">
        { helmet }
        <div className='container'>
            <div className="content">
                <Banner />
                <br />
                <div class="ui-block game-ui-block">
                    <div class="game">
                        <div class="game__top">
                            <Breadcrumbs data={breadcrumbsData()}/>
                        </div>
                        <div class="game__middle">
                            <div className="game__command">
                                <div className="game__icon">
                                    <img src={participantA.imagePath} alt="" />
                                </div>
                                <div className="game__command-name">
                                    {participantA.name}
                                </div>
                            </div>
                            <div className="game__info">
                                <div className="game__status">{status()}</div>
                                { score() }
                                <div className="game__time">{ time() }</div>
                            </div>
                            <div className="game__command">
                                <div className="game__icon">
                                    <img src={participantB.imagePath} alt="" />
                                </div>
                                <div className="game__command-name">
                                    {participantB.name}
                                </div>
                            </div>
                        </div>
                        <div class="game__bottom">
                            <div class="nav-list league__nav-list">
                                <button 
                                class={currentTab == '' || !currentTab ? "nav-list__point nav-list__point--current" : "nav-list__point"} 
                                onClick={() => navigate(`/match/${matchid}/`)}>
                                    <span class="nav-list__text">матч</span>
                                    <div class="nav-list__line"></div>
                                </button>
                                <button 
                                class={currentTab == 'coefficients' ? "nav-list__point nav-list__point--current" : "nav-list__point"} 
                                onClick={() => navigate('./coefficients')}>
                                    <span class="nav-list__text">коэфф.</span>
                                    <div class="nav-list__line"></div>
                                </button>
                                <button 
                                class={currentTab == 'h2h' ? "nav-list__point nav-list__point--current" : "nav-list__point"} 
                                onClick={() => navigate('./h2h')}>
                                    <span class="nav-list__text">h2h</span>
                                    <div class="nav-list__line"></div>
                                </button>
                                <button 
                                class={currentTab == 'table' ? "nav-list__point nav-list__point--current" : "nav-list__point"} 
                                onClick={() => navigate('./table')}>
                                    <span class="nav-list__text">таблица</span>
                                    <div class="nav-list__line"></div>
                                </button>
                                <button 
                                class={currentTab == 'teams' ? "nav-list__point nav-list__point--current" : "nav-list__point"} 
                                onClick={() => navigate('./teams')}>
                                    <span class="nav-list__text">Составы</span>
                                    <div class="nav-list__line"></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ui-block">
                    <Routes>
                        <Route index element={
                            <>
                                <MatchProgress />
                                <MatchStatistic />
                            </>
                        }/>
                        <Route path="coefficients" element={<MatchCoefficients />}/>
                        <Route path="h2h" element={<H2H />}/>
                        <Route path="table" element={<MatchTable />}/>
                        <Route path="teams" element={<TeamArrangement matchId={matchid}/>}/>
                        <Route path="*" element={<Navigate to=".." replace />}/>
                    </Routes>
                </div>
            </div>
        </div>
    </section>);
}

export default Match; 
